import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { UseTimeZone } from '../../../../common/hooks/useTimeZone'
import { SCREEN } from '../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../common/selectCurrencyUnit/useFormatCurrency'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'
import { formatText } from '../../../../helpers/value'
import { TABLE_HEAD } from './helper'

export const ThCell = ({ rowId, col, colIndex }) => {
  const isRatioNameCell = col.colId.startsWith('RatioName')

  const locale = useSelector((state) => state.i18n.locale)
  const timezone = UseTimeZone()
  const { formatedUnit } = useFormatCurrency(SCREEN.FINANCIAL_STATEMENT)
  const label = UseI18n(`financialStatement.dynamicTable.${rowId}`)

  const rederContent = () => {
    if (colIndex === 0 && rowId !== TABLE_HEAD.AS_AT) {
      return label
    }

    if (col?.colId?.startsWith('RatioName')) return ''

    switch (rowId) {
      case TABLE_HEAD.FY:
        return formatDateTime(col.fiscalYearEnd, FORMAT.DATE, locale, timezone)
      case TABLE_HEAD.UNIT:
        return formatedUnit
      case TABLE_HEAD.AUDIT_STATUS:
        return (
          <Translate
            value={
              col.isAudit
                ? 'financialStatement.AUDITED'
                : 'financialStatement.UNAUDITED'
            }
          />
        )
      case TABLE_HEAD.TYPE:
        return (
          <Translate
            value={
              col.isSingleEntity
                ? 'financialStatement.SINGLE_ENTITY'
                : col.isConsolidate
                ? 'financialStatement.CONSOLIDATED'
                : 'financialStatement.UNCONSOLIDATED'
            }
          />
        )
      case TABLE_HEAD.LEGAL_REGULATION:
        return formatText(col.reportFormCode)
      case TABLE_HEAD.SOURCE:
        return formatText(col.sourceOrganizationName)
      case TABLE_HEAD.METHOD:
        return (
          <Translate
            value={
              col.isDirect
                ? 'financialStatement.DIRECT'
                : 'financialStatement.INDIRECT'
            }
          />
        )
      default:
        break
    }
  }

  return (
    <th
      key={col.colId}
      style={{
        textAlign: isRatioNameCell ? 'left' : 'right',
        fontWeight: [TABLE_HEAD.AS_AT, TABLE_HEAD.FY, TABLE_HEAD.UNIT].includes(
          rowId,
        )
          ? 600
          : 400,
        fontStyle: 'italic',
        borderBottom: 'none',
        padding: '2px 12px',
      }}
    >
      {rederContent()}
    </th>
  )
}
